import FaqPage from "~/components/Faq/FaqPage";

const WorkingWithAnAgent = () => {
  return (
    <FaqPage
      selected={"working-with-an-agent"}
      description={
        "A list of Frequently Asked Questions (FAQs) from our clients about working with agents from RealEstateAgents.com."
      }
    />
  );
};

export default WorkingWithAnAgent;
